<template>
  <div
    class="topper-banner"
    :style="{
      backgroundColor: type === 'carousel' ? data[bannerIndex].bgColor : '#141c2f'
    }"
  >
    <div
      v-for="(item, index) in data"
      v-show="bannerIndex == index"
      :key="index"
      class="position-bg"
      :style="{
        backgroundColor: `${item.bgColor}`
      }"
    ></div>
    <template v-if="type === 'banner' && data.length > 0">
      <div v-if="showNotice" class="absolute left-0 top-75 z-50  w-screen bg-[#2b4e8a7f] text-white">
        <div style="width: 1400px; margin: 0 auto;height: auto;padding: 2px 0 " class="flex h-30 items-center justify-between" >
          <div>
            <i class="iconfont icon-laba mr-20"></i>
            <span>
<!--              <span style="font-weight: bold;">SteamDT网络环境优化公告：</span><span style="color: #ffffffd9;">SteamDT于2026-04-23对网络进行优化，期间访问可能异常。我们将尽快解决,请耐心等待。</span>-->
              <span style="font-weight: bold;">Steam成交相关修复中公告：</span><span style="color: #ffffffd9;">因Steam接口变动，导致Steam成交量及成交额异常，正在修复中...修改完成后以公告告知</span>
<!--              <span style="font-weight: bold;">SteamDT APP公告：</span><span style="color: #ffffffd9;">SteamDT APP安卓正式版1.0.2已发布(苹果版本因审核未通过,上线时间待定)。安卓版下载地址：https://cdn.steamdt.com/APP/SteamDT-1.0.2.apk</span>-->
<!--              <span style="font-weight: bold;">SteamDT APP发布公告：</span><span style="color: #ffffffd9;">SteamDT APP安卓正式版1.0.1已发布(苹果版本审核中,预计4月初上线)。安卓版下载地址：https://cdn.steamdt.com/APP/SteamDT-1.0.1.apk</span>-->
<!--              <span style="font-weight: bold;">热门板块数据优化公告：</span><span style="color: #ffffffd9;">为提升用户体验，减少毛刺数据，正对数据进行优化中,期间最新小时数据可能存在波动，预计2026-2-27 20:00维护完毕。</span>-->
<!--              <span style="font-weight: bold;">开放平台新增K线API接口公告：</span><span style="color: #ffffffd9;">为响应用户需求，提升用户使用体验，现已开放K线API接口。<a href="https://doc.steamdt.com/428124801e0" target="_blank" style="text-decoration: underline;color: #0097f3;">K线API接口文档</a>。</span>-->
<!--              <span style="font-weight: bold;">三方插件更新公告：</span><span style="color: #ffffffd9;">我的库存中使用的三方插件现已更新，修复了勾选BUFF上传数据时，因交易记录存在特殊款式导致上传异常的BUG，请重新下载使用！<span  style="font-weight: bold;color: #ffffff;"><a href="https://www.yuque.com/zilonggege-h3als/kuwu70/ntq163dkdqmpdekg#n0lnB" target="_blank" style="text-decoration: underline;color: #0097f3;">插件更新教程</a></span></span>-->
            </span>
          </div>
          <div>
            <i class="iconfont icon-guanbi1 cursor-pointer" @click="closeNotice"></i>
          </div>
        </div>
      </div>
      <el-carousel arrow="never" height="330px" :attr="data.length" @change="changeCarousel">
        <el-carousel-item v-for="(item, index) in data" :key="index">
          <div
            class="banner-bg"
            :style="{
              backgroundColor: item.bgColor
            }"
          >
            <a :href="item.href" v-if="item.href" target="_blank">
              <img :src="item.imgUrl" alt="" />
            </a>
            <img :src="item.imgUrl" v-else alt="" />
          </div>
        </el-carousel-item>
      </el-carousel>
    </template>

    <template v-else>
      <div class="position-bg" style="background-color: #000233"></div>
      <div class="banner-bg">
        <img src="~/assets/images/header-bgs/index-header-bg2.jpg" alt="" />
      </div>
    </template>
  </div>
</template>

<script setup>
import bannerConfig from '~~/constants/banner-config'
import banner from '~/components/layout/banner.vue'

const route = useRoute()
const router = useRouter()
const showNotice = ref(false)
const versionNumber = ref('V57')
const readedNotice = useLocalStorage('readedNotice')
const store = useNuxtStore()

watch(
  () => store.isBindSteam,
  () => {
    if (store.isBindSteam && routeNameFirstPart.value === 'inventory-my') {
      data.value = []
    }
  }
)
watch(
  () => router.currentRoute.value.name,
  toPath => {
    routeNameFirstPart.value = toPath ? toPath.split('_')[0] : ''
    if (routeNameFirstPart.value !== 'index') {
      showNotice.value = false
    } else {
      if (readedNotice.value !== versionNumber.value) {
        showNotice.value = true
      }
    }

    if (bannerConfig[routeNameFirstPart.value]) {
      data.value = bannerConfig[routeNameFirstPart.value]
    }
    if (store.isBindSteam && routeNameFirstPart.value === 'inventory-my') {
      data.value = []
    }
  }
)
const routeNameFirstPart = ref(route.name ? route.name.split('_')[0] : '')

const data = ref([])

onMounted(() => {
  if (readedNotice.value !== versionNumber.value && routeNameFirstPart.value === 'index') {
    showNotice.value = true
  }
})

if (bannerConfig[routeNameFirstPart.value]) {
  data.value = bannerConfig[routeNameFirstPart.value]
}
const props = defineProps({
  type: {
    type: String,
    default: 'banner'
  }
})
const bannerIndex = ref(0)

const changeCarousel = e => {
  bannerIndex.value = e
}

const openUrl = param => {
  if (param) {
    window.open(param)
  }
}

const closeNotice = () => {
  showNotice.value = false
  readedNotice.value = versionNumber.value
}
</script>

<style lang="scss" scoped>
.topper-banner {
  width: 1400px;
  z-index: 10;
  margin: 0 auto;
  .position-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 330px;
    z-index: 1;
  }
  :deep(.el-carousel) {
    min-width: 1920px;
    position: relative;
    left: -260px;
    z-index: 2;
    .el-carousel__indicators {
      bottom: 40px;
    }
    .el-carousel__indicator--horizontal {
      padding: 0 5px;

      &.is-active {
        .el-carousel__button {
          background: $primary-color;
        }
      }
    }
    .el-carousel__button {
      width: 40px;
      height: 10px;
      background: #f7f7f8;
      border-radius: 5px;
      opacity: 1;
    }
  }

  .banner-bg {
    height: 330px;
    img {
      display: block;
      height: 100%;
      margin: 0 auto;
    }
  }
}
</style>
